import classNames from "classnames";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { PropsWithDataQaid } from "src/types/componentProps";

type IconProps = FontAwesomeIconProps &
  PropsWithDataQaid<{
    /**
     * Set the icon
     * see these links for icon usage:
     *   - https://github.com/FortAwesome/react-fontawesome
     */
    icon: IconProp;
  }>;

function Icon(props: IconProps) {
  const { icon, className, "data-qaid": dataQaid, ...restProps } = props;
  const iconClass = classNames("c-icon", className);

  return (
    <FontAwesomeIcon
      data-testid="qa-icon"
      icon={icon}
      className={iconClass}
      {...restProps}
      data-qaid={`${dataQaid}-icon`}
    />
  );
}

export default Icon;
